import { OrderType } from '@schemas'
import {
	downloadOrderDocument,
	OrderDocumentModel,
	OrderDocumentRow,
} from '../order/orderDocument'
import {
	wholesaleMoney,
	wholesaleStatusTitle,
	wholesaleAddress,
	wholesaleDate,
	wholesaleDateTime,
	hasWholesaleShipment,
} from './wholesaleOrder.format'

/**
 * 도매 주문 한 건 → PDF 문서 모델. 조판은 공용(order/orderDocument.ts).
 */
export const wholesaleOrderDocumentModel = (order: OrderType): OrderDocumentModel => {
	const money = (v: number) => wholesaleMoney(order.currency, v)
	const shipped = hasWholesaleShipment(order)

	const payment: OrderDocumentRow[] = [
		['Subtotal', money(order.totalAmount)],
		...(order.vatAmount > 0 ? [['VAT', money(order.vatAmount)] as OrderDocumentRow] : []),
		...(order.shippingAmount > 0
			? [['Shipping', money(order.shippingAmount)] as OrderDocumentRow]
			: []),
		...(order.dutyAmount > 0
			? [['Duties', money(order.dutyAmount)] as OrderDocumentRow]
			: []),
		[`Total (${order.currency})`, money(order.paidAmount), true],
		[
			'Paid',
			order.paidYn === 1 && order.paidAt ? wholesaleDate(order.paidAt) : 'Not yet',
		],
	]

	return {
		kind: 'WHOLESALE ORDER',
		id: order.id,
		facts: [
			`Placed ${wholesaleDateTime(order.createdAt)}`,
			wholesaleStatusTitle(order),
			order.currency,
		].join('   ·   '),
		items: order.detailList.map(anItem => ({
			name: anItem.productName,
			unit: money(anItem.unitAmount),
			qty: String(anItem.quantity),
			total: money(anItem.unitAmount * anItem.quantity),
		})),
		sections: [
			{ title: 'Payment', rows: payment, alignRight: true },
			{
				title: 'Recipient',
				rows: [
					[
						'Name',
						`${order.receiverGivenName ?? ''} ${order.receiverFamilyName ?? ''}`.trim(),
					],
					['Address', wholesaleAddress(order)],
				],
				alignRight: false,
			},
			{
				title: 'Shipping',
				rows: [
					['Carrier', shipped ? order.deliveryCompany : '-'],
					['Tracking No.', shipped ? order.trackingNumber : '-'],
					...(order.deliveryCompletedAt
						? [
								[
									'Delivered',
									wholesaleDate(order.deliveryCompletedAt),
								] as OrderDocumentRow,
						  ]
						: []),
				],
				alignRight: false,
			},
		],
	}
}

export const downloadWholesaleOrderDocument = (order: OrderType): Promise<void> =>
	downloadOrderDocument(
		wholesaleOrderDocumentModel(order),
		`judahs-wholesale-order-${order.id}.pdf`,
	)
